// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel {
    'phoneNumberId'?: number;
    'isVmOptedIn'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel>> = [
        {
            "name":     "phoneNumberId",
            "baseName": "phoneNumberId",
            "type":     "number"
        },
        {
            "name":     "isVmOptedIn",
            "baseName": "isVmOptedIn",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsVoicemailOptInModel.attributeTypeMap;
    }
}
